"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HelpButtonTopBar = void 0;
const auth0_react_1 = require("@auth0/auth0-react");
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const Button_1 = __importDefault(require("../../../common/js/atoms/Button"));
const ButtonVariant_1 = __importDefault(require("../../../common/js/enums/ButtonVariant"));
const Zupicons_1 = __importDefault(require("../../../common/js/enums/Zupicons"));
const useHelpUrl_1 = __importDefault(require("../../hooks/useHelpUrl"));
const HelpButtonTopBar = () => {
    const url = (0, useHelpUrl_1.default)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isAuthenticated } = (0, auth0_react_1.useAuth0)();
    const onClick = (0, react_1.useCallback)((event) => {
        event.preventDefault();
        window.open(url, '_blank');
    }, [url]);
    if (!url || !isAuthenticated) {
        return null;
    }
    return (react_1.default.createElement("div", { className: "znd-top-bar__icon-button", title: t('help.button_title') ?? undefined },
        react_1.default.createElement(Button_1.default, { variant: ButtonVariant_1.default.light, icon: Zupicons_1.default.question, onClick: onClick })));
};
exports.HelpButtonTopBar = HelpButtonTopBar;
exports.default = exports.HelpButtonTopBar;
